import { useState, useEffect } from "react";
import { tv } from "../../lib/api/api";
import { Link } from "react-router-dom";

const AnnouncementCard = ({data}) => {
    const {id, name, anons, media, channel_id, dates} = data;
    const [channelName, setChannelName] = useState('');
    const [channelLogo, setChannelLogo] = useState({});
    const [url, setUrl] = useState('');
    const [start, setStart] = useState('');

    useEffect(() => {
        if (media.type === 'banner') {
            setUrl(media[0].url);
        }
        if (dates.start_at) {
            setStart(changeOfDate(dates.start_at));
        } else {
            setStart(changeOfDate(dates.created_at));
        }
        tv.tvChannels()
            .then((res) => {
                res.channels.forEach(item => {
                    if (item.id === channel_id) {
                        setChannelName(item.name);
                        setChannelLogo(item.media.default);
                    }
                });
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    function changeOfDate(date) {
        let newDate = '';
        const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
        const index = Number(date.slice(5, 7));
        newDate += `${date.slice(8, 10)} ${months[index - 1]} ${date.slice(11, 16)}`;
        return newDate;
    }

    return (
        <>
            <div className="announcement-card">
                <div className="announcement-card__wrap page__area">
                    <Link className="announcement-card__pic-wrap" to={`//telekarta.tv/announcements/${id}`}>
                        <img className="announcement-card__img" alt={name} width="auto" height="auto" src={url}/>
                    </Link>
                    <div className="announcement-card__info-container">
                        <div>
                            <Link className="announcement-card__heading title title--h4" to={`//telekarta.tv/announcements/${id}`}>{name}</Link>
                            <div className="announcement-card__description text text--sub">
                                <p>{anons}</p>
                            </div>
                        </div>
                        <div className="announcement-card__footer">
                            <span className="announcement-card__date">{start}</span>
                            <img className="announcement-card__channel-img" src={channelLogo.url} width="50" height="50" alt={channelName}/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AnnouncementCard;